import OfferManagement from "../Components/MerchantManagement/CardOfferManagement";

const endpoints = {
  SIGNUP: "merchant/sign_up",
  SIGNIN: "admin/adminlogin",
  DASHBOARD: `admin/deshboard`,
  MERCHANTKYCLIST: "admin/merchant_kyc_list",
  KYCVERIFY: "admin/verify_kyc",
  FORGOTPASSWORD: "admin/forgot_password",
  OTPVERIFICATION: "admin/verify_otp",
  OfferManagement: "admin/offer_list",
  CreateCategory: "admin/create_category",
  GetAllCategor: "admin/category_list",
  UPDATEQUERY: (id) => `admin/update_enquiry_status${id}`,
  GENERALENQUIRIES: "admin/genral_enquiry",
  MERCHANTLIST: "admin/merchnt_list",
  MERCHANTSTATUS:(queryString) => `admin/update_status?${queryString}`,
  OFFERCARDSTATUS : "admin/update_offer_status",
  BANNEROFFERLIST:"admin/banner_list",
  BANNERCARDOFFER :"admin/update_banner_status",
  CUSTOMERLIST:(queryString)=>`admin/user_list?${queryString}`,
  MERCHANTTRANSACTIONLIST :"admin/merchant_transaction",
  GETPROFILE: "admin/profile_details",
  RESENDOTP: "admin/forgot_password",
  RESETPASSWORD: "admin/reset_Password",
  CASHFUSECUSTOMER: "merchant/casefuse_customer",
  
  UPDATEPROFILE: "merchant/update_profile",
  TRANSECTION: "merchant/payment_history",
  CATEGORYLIST: "merchant/category_list",
  CONTACTUS: "user/contact_us",
  ADDOFFER: "merchant/add_offer",
  GETOFFER: "merchant/get_offer",
  TERMSCONDATION: "merchant/add_terms",
  GETTREAM: "merchant/get_terms",
  AddFAQ: "merchant/addFaq",
  GETFAQ: "merchant/getFaq",
  ADDOFFERUPDATE: "merchant/update_offer",
  ADDBANNER: "/merchant/add_banner",
  GETBANNER: "/merchant/get_banner",
  ADDBANNERUODATE: "/merchant/update_banner",
};

export { endpoints };
